import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpLoadingService } from '../../services/http-loading.service';
import { Observable } from 'rxjs';
import { SpinnerFullscreenComponent } from '@web/shared/ui';

@Component({
  selector: 'app-http-loading',
  imports: [CommonModule, SpinnerFullscreenComponent],
  templateUrl: './http-loading.component.html',
  styleUrl: './http-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HttpLoadingComponent {
  private readonly httpLoading = inject(HttpLoadingService);

  protected readonly loading$ = this.loadingSource();

  private loadingSource(): Observable<boolean> {
    return this.httpLoading.loading$;
  }
}
